// import "./polyfills";
import "./components/gdpr-banner";
import "./components/main-nav";
import "./components/top-search";
import "./components/scroll-top";
import "./components/page-actions";
import "./components/dialog";
import "./components/login-dialog";
import "./components/publications-dialog";
import "./components/live-chat";

(() => {
	document.addEventListener("DOMContentLoaded", () => {
		// When our apps load the layout, the shared layout url is the url put in the
		// returnUrl param for the login form, which is not correct.
		const loginForm = document.querySelector("#loginDialog form") as HTMLFormElement;
		let formAction = loginForm?.getAttribute("action");

		if (!formAction) {
			return;
		}

		let formActionQueryString = formAction.split("?")[1];
		formActionQueryString = formActionQueryString.split("&").map(queryParam => {
			if (!queryParam.toLowerCase().startsWith("returnurl=")) {
				return queryParam;
			}
			if (queryParam.toLowerCase().indexOf("sharedlayout") === -1) {
				return queryParam;
			}
			return `returnUrl=${encodeURIComponent(window.location.href)}`;
		}).join("&");

		formAction = `${formAction.split("?")[0]}?${formActionQueryString}`;

		loginForm.setAttribute("action", formAction);
	});
})();
